/**
 * @generated SignedSource<<b3757656f8fd82b21ffd26b1898c61b5>>
 * @relayHash 8fd49bd0312f6d5589fd1c1c2fc17af2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b64e72fceea76e7da367bb5849a0a3676fe29b6e165127fe9b719ca3efa2da55

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CalendarContentQuery } from './CalendarContentQuery.graphql';

const node: PreloadableConcreteRequest<CalendarContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b64e72fceea76e7da367bb5849a0a3676fe29b6e165127fe9b719ca3efa2da55",
    "metadata": {},
    "name": "CalendarContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
